<script>
  import { blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link, links } from "svelte-routing";

  export let block;
</script>

<section>
  <div class="container" data-aos="fade-up">
    <header class="section-header">
      <p>{text(block, 'headline')}</p>
    </header>
    <div>
      {@html richtext(block, 'body')}
    </div>
  </div>
</section>
